import {FreeSpinsInProgressState, FreeSpinsModule, GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot';
import {GameLogic} from 'src/server/GameLogic';

export class GameFreeSpinsInProgressState extends FreeSpinsInProgressState {
    protected onFinished(): void {
        if (!this._isOutroPopupShowed) {
            const logic = this.module.logic as GameLogic;

            this.module.soundPlayer.stopMusic();
            this.module.soundPlayer.play('freegameend');
            this._isOutroPopupShowed = true;

            if (logic.getTotalWin()) {
                const type = GenericPopupType.FREESPIN_OUTRO;
                const fgBonus = logic.getFreeGames();

                this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type), fgBonus.getFreeGameType());
            } else {
                this.emit(GenericPopupEvents.SHOW_POPUP, GenericPopupType.FREESPIN_OUTRO_NO_WIN);
            }
            this.module.gotoState(FreeSpinsModule.BASIC_STATE);
        }
    }
}
